import React from 'react';
import { EditModGroupRestaurantPropertiesState } from './editModGroupRestaurantPropertiesState/EditModGroupRestaurantPropertiesState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

export const EditModifierGroupRestaurantPropertiesPage: React.FC = () => {
	return (
		<EditModGroupRestaurantPropertiesState>
			<Forms />
			<ModalWindows />
		</EditModGroupRestaurantPropertiesState>
	);
};
